import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";

export default class extends Typed(
    Controller<HTMLLinkElement>, {
        values: {
            message: {type: String, default: 'Are you sure you want to proceed?'},
            url: String,
        }
    }
)
{
    public connect(): void {
        if (this.element.tagName !== 'A') {
            throw new Error('The ConfirmLinkController can only be used on <a> elements.');
        }
        this.urlValue = this.element.getAttribute('href') || '';
        this.element.setAttribute('href', 'javascript:void(0);');
    }

    public confirm(): void {
        if (confirm(this.messageValue)) {
            window.location.href = this.urlValue;
        }
    }
}
